export default __webpack_public_path__ + "static/media/trash.f91b7061.svg";